(function () {
  const cfg = window.SHABA_CART_POPUP_CONFIG || {};
  const moneyFormat = cfg.moneyFormat || "{{amount}}";
  const threshold = Number(cfg.freeShippingThresholdCents || 0);
  const requireConsent = Boolean(cfg.requireConsent);

  const overlay = document.querySelector(".shaba-cart-overlay");
  const modal = document.querySelector(".shaba-cart-modal");
  if (!overlay || !modal) return;

  const closeBtn = modal.querySelector(".shaba-cart-close");
  const continueBtn = modal.querySelector(".shaba-cart-continue");
  const remainingEl = modal.querySelector(".shaba-cart-remaining");
  const barEl = modal.querySelector(".shaba-cart-progress-bar");
  const countEl = modal.querySelector(".shaba-cart-count");
  const totalEl = modal.querySelector(".shaba-cart-total");
  const imgEl = modal.querySelector(".shaba-cart-product-img");
  const titleEl = modal.querySelector(".shaba-cart-product-title");
  const priceEl = modal.querySelector(".shaba-cart-product-price");
  const qtyEl = modal.querySelector(".shaba-cart-qty");
  const lineTotalEl = modal.querySelector(".shaba-cart-line-total");
  const consentCheck = modal.querySelector(".shaba-cart-consent-check");
  const checkoutBtn = modal.querySelector(".shaba-cart-checkout");

  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    return moneyFormat
      .replace("{{amount}}", value)
      .replace("{{ amount }}", value);
  }

  function openModal() {
    overlay.hidden = false;
    modal.hidden = false;
    document.documentElement.style.overflow = "hidden";
  }

  function closeModal() {
    overlay.hidden = true;
    modal.hidden = true;
    document.documentElement.style.overflow = "";
  }

  function setCheckoutEnabled(enabled) {
    if (!checkoutBtn) return;
    checkoutBtn.setAttribute("aria-disabled", enabled ? "false" : "true");
  }

  async function getCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("cart.js failed");
    return await res.json();
  }

  function findLineByVariantId(cart, variantId) {
    if (!cart || !Array.isArray(cart.items)) return null;
    return cart.items.find((it) => String(it.variant_id) === String(variantId)) || null;
  }

  function updateFreeShipping(cartTotalCents) {
    if (!threshold || threshold <= 0) {
      remainingEl.textContent = formatMoney(0);
      barEl.style.width = "100%";
      return;
    }

    const remaining = Math.max(threshold - cartTotalCents, 0);
    remainingEl.textContent = formatMoney(remaining);

    const progress = Math.min((cartTotalCents / threshold) * 100, 100);
    barEl.style.width = progress.toFixed(2) + "%";
  }

  async function renderPopup(lastAddedVariantId, addResponseItem) {
    const cart = await getCart();

    // Summary
    if (countEl) countEl.textContent = String(cart.item_count || 0);
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price || 0);

    updateFreeShipping(cart.total_price || 0);

    // Product panel
    let line = findLineByVariantId(cart, lastAddedVariantId);

    // Fallback: use add response item if line not found yet
    const title = (line && line.product_title) || (addResponseItem && addResponseItem.product_title) || "";
    const img =
      (line && (line.image || (line.featured_image && line.featured_image.url))) ||
      (addResponseItem && (addResponseItem.image || (addResponseItem.featured_image && addResponseItem.featured_image.url))) ||
      "";
    const qty = (line && line.quantity) || (addResponseItem && addResponseItem.quantity) || 1;

    const unitPrice = (line && line.final_price) || (addResponseItem && addResponseItem.final_price) || 0;
    const lineTotal = (line && line.final_line_price) || (unitPrice * qty);

    if (titleEl) titleEl.textContent = title;
    if (imgEl) {
      imgEl.src = img || "";
      imgEl.alt = title || "Added product";
    }
    if (priceEl) priceEl.textContent = formatMoney(unitPrice);
    if (qtyEl) qtyEl.textContent = String(qty);
    if (lineTotalEl) lineTotalEl.textContent = formatMoney(lineTotal);

    // Consent logic
    if (requireConsent && consentCheck && checkoutBtn) {
      setCheckoutEnabled(consentCheck.checked);
      consentCheck.addEventListener("change", () => setCheckoutEnabled(consentCheck.checked), { once: false });
    } else {
      setCheckoutEnabled(true);
    }

    openModal();
  }

  async function addToCartAjax(form) {
    const formData = new FormData(form);

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formData,
      credentials: "same-origin",
    });

    if (!res.ok) {
      // If something fails, fallback to normal submit
      form.submit();
      return;
    }

    const data = await res.json();
    const variantId = data && data.variant_id ? data.variant_id : formData.get("id");

    await renderPopup(variantId, data);
  }

  // Bind all add-to-cart forms (including your product-form)
  function bindForms() {
    document.addEventListener("submit", function (e) {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;

      const action = (form.getAttribute("action") || "").toLowerCase();
      const isAdd = action.includes("/cart/add") || form.querySelector('input[name="id"]');
      if (!isAdd) return;

      // Avoid interfering with cart page default forms if you want
      if (form.closest(".cart")) return;

      e.preventDefault();
      addToCartAjax(form);
    });
  }

  overlay.addEventListener("click", closeModal);
  closeBtn && closeBtn.addEventListener("click", closeModal);
  continueBtn && continueBtn.addEventListener("click", closeModal);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !modal.hidden) closeModal();
  });

  bindForms();
})();